import { render, staticRenderFns } from "./organisationalChart.vue?vue&type=template&id=44b62477"
import script from "./organisationalChart.vue?vue&type=script&lang=js"
export * from "./organisationalChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports